import React, { ReactNode, useEffect, useRef, useState } from 'react';

interface HelpTipProps {
    label?: string;
    wide?: boolean;
    children: ReactNode;
}

const HelpTip: React.FC<HelpTipProps> = ({ label = 'Help', wide = false, children }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if (!open) {
            return;
        }

        const handlePointerDown = (event: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open]);

    return (
        <span className={`help-tip${wide ? ' is-wide' : ''}${open ? ' is-open' : ''}`} ref={rootRef}>
            <button
                type="button"
                className="help-tip-icon"
                aria-label={label}
                aria-expanded={open}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setOpen((current) => !current);
                }}
            >
                ?
            </button>
            <div className="help-tip-panel" role="tooltip">
                {children}
            </div>
        </span>
    );
};

export default HelpTip;
